module.exports = __webpack_public_path__ + "static/media/score_result_4.b5ca7037.png";